var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bea4376eadd4c6ce5c683f9cbf6a3a4941d02f0b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["elo-cabinets@ablefy"]={id:"bea4376eadd4c6ce5c683f9cbf6a3a4941d02f0b"};
      